// extracted by mini-css-extract-plugin
export default {"btop":"fd59b534d2 _66d9518b56 _448272eb63","icon":"fb305bfc96 _396eaa0cc5","btoppink":"_4be5d90f06 _66050e0f9b"};